import React, { useState } from 'react';
import { FileText, Shield, Cookie, Scale, ChevronRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';
import ScrollProgress from '../components/ScrollProgress';

const Legal = () => {
  const [activeTab, setActiveTab] = useState('privacy');

  const tabs = [
    { id: 'privacy', title: 'Gizlilik Politikası', icon: Shield },
    { id: 'terms', title: 'Kullanım Koşulları', icon: FileText },
    { id: 'cookies', title: 'Çerez Politikası', icon: Cookie },
    { id: 'kvkk', title: 'KVKK Aydınlatma Metni', icon: Scale }
  ];

  const content = {
    privacy: {
      title: 'Gizlilik Politikası',
      lastUpdated: '15 Aralık 2025',
      sections: [
        {
          title: '1. Genel Bilgiler',
          content: `RUYAN Bilişim olarak, kişisel verilerinizin güvenliği bizim için son derece önemlidir. Bu gizlilik politikası, web sitemizi ziyaret ettiğinizde veya hizmetlerimizi kullandığınızda kişisel verilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklamaktadır.`
        },
        {
          title: '2. Toplanan Veriler',
          content: `İletişim formu aracılığıyla gönderdiğiniz ad, soyad, e-posta adresi, telefon numarası ve mesaj içeriği gibi bilgileri topluyoruz. Ayrıca, web sitemizi ziyaretiniz sırasında IP adresi, tarayıcı türü, ziyaret edilen sayfalar ve ziyaret süresi gibi teknik bilgiler otomatik olarak toplanabilir.`
        },
        {
          title: '3. Verilerin Kullanımı',
          content: `Toplanan veriler; taleplerinize yanıt vermek, hizmetlerimizi geliştirmek, pazarlama faaliyetleri yürütmek (izniniz dahilinde), yasal yükümlülüklerimizi yerine getirmek ve güvenliği sağlamak amacıyla kullanılmaktadır.`
        },
        {
          title: '4. Veri Güvenliği',
          content: `Kişisel verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz. SSL şifreleme, güvenli sunucular ve düzenli güvenlik denetimleri ile verilerinizin güvenliğini sağlıyoruz.`
        },
        {
          title: '5. Üçüncü Taraflarla Paylaşım',
          content: `Kişisel verilerinizi, yasal zorunluluklar dışında, izniniz olmadan üçüncü taraflarla paylaşmıyoruz. Hizmet sağlayıcılarımızla (hosting, analitik vb.) paylaşılan veriler gizlilik sözleşmeleri ile korunmaktadır.`
        }
      ]
    },
    terms: {
      title: 'Kullanım Koşulları',
      lastUpdated: '15 Aralık 2025',
      sections: [
        {
          title: '1. Kabul',
          content: `Bu web sitesini kullanarak, aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız. Bu koşulları kabul etmiyorsanız, lütfen sitemizi kullanmayınız.`
        },
        {
          title: '2. Hizmet Tanımı',
          content: `RUYAN Bilişim, mobil uygulama geliştirme, web tasarım, yapay zeka entegrasyonu ve dijital pazarlama alanlarında hizmet veren bir teknoloji şirketidir. Bu site, hizmetlerimiz hakkında bilgi vermek ve potansiyel müşterilerle iletişim kurmak amacıyla kullanılmaktadır.`
        },
        {
          title: '3. Fikri Mülkiyet',
          content: `Bu web sitesindeki tüm içerik, tasarım, logo, metin, grafik ve diğer materyaller RUYAN Bilişim'in mülkiyetindedir ve telif hakları ile korunmaktadır. İzinsiz kullanım yasaktır.`
        },
        {
          title: '4. Sorumluluk Sınırlaması',
          content: `Bu web sitesindeki bilgiler yalnızca bilgilendirme amaçlıdır. RUYAN Bilişim, sitedeki bilgilerin doğruluğu, eksiksizliği veya güncelliği konusunda garanti vermez.`
        },
        {
          title: '5. Değişiklikler',
          content: `RUYAN Bilişim, bu kullanım koşullarını önceden haber vermeksizin değiştirme hakkını saklı tutar. Güncel koşulları düzenli olarak kontrol etmenizi öneririz.`
        }
      ]
    },
    cookies: {
      title: 'Çerez Politikası',
      lastUpdated: '15 Aralık 2025',
      sections: [
        {
          title: '1. Çerez Nedir?',
          content: `Çerezler, web sitemizi ziyaret ettiğinizde cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, web sitemizin düzgün çalışmasını sağlar ve ziyaret deneyiminizi iyileştirir.`
        },
        {
          title: '2. Kullandığımız Çerez Türleri',
          content: `• Zorunlu Çerezler: Web sitesinin temel işlevleri için gereklidir.\n• Performans Çerezleri: Sitemizin nasıl kullanıldığını anlamamıza yardımcı olur.\n• İşlevsellik Çerezleri: Tercihlerinizi hatırlamamızı sağlar.\n• Hedefleme Çerezleri: Size ilgili reklamlar göstermek için kullanılır.`
        },
        {
          title: '3. Çerez Yönetimi',
          content: `Tarayıcı ayarlarınızdan çerezleri yönetebilir veya engelleyebilirsiniz. Ancak, bazı çerezleri engellemek web sitemizin bazı özelliklerinin düzgün çalışmamasına neden olabilir.`
        },
        {
          title: '4. Üçüncü Taraf Çerezleri',
          content: `Web sitemizde Google Analytics gibi üçüncü taraf hizmetleri kullanıyoruz. Bu hizmetler kendi çerezlerini kullanabilir ve kendi gizlilik politikalarına tabidir.`
        }
      ]
    },
    kvkk: {
      title: 'KVKK Aydınlatma Metni',
      lastUpdated: '15 Aralık 2025',
      sections: [
        {
          title: '1. Veri Sorumlusu',
          content: `6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz veri sorumlusu sıfatıyla RUYAN Teknoloji ve Bilişim Hizmetleri Ltd. Şti. tarafından işlenmektedir.`
        },
        {
          title: '2. İşlenen Kişisel Veriler',
          content: `• Kimlik Bilgileri: Ad, soyad\n• İletişim Bilgileri: E-posta adresi, telefon numarası\n• İşlem Güvenliği Bilgileri: IP adresi, log kayıtları\n• Pazarlama Bilgileri: Çerez kayıtları, cihaz bilgileri`
        },
        {
          title: '3. Veri İşleme Amaçları',
          content: `Kişisel verileriniz; iletişim taleplerinin karşılanması, hizmetlerin sunulması, pazarlama faaliyetlerinin yürütülmesi, yasal yükümlülüklerin yerine getirilmesi ve bilgi güvenliğinin sağlanması amaçlarıyla işlenmektedir.`
        },
        {
          title: '4. Haklarınız',
          content: `KVKK'nın 11. maddesi uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmişse düzeltilmesini isteme, silinmesini veya yok edilmesini isteme haklarına sahipsiniz.`
        },
        {
          title: '5. Başvuru',
          content: `KVKK kapsamındaki haklarınızı kullanmak için info@ruyan.com.tr adresine e-posta gönderebilir veya şirket adresimize yazılı başvuruda bulunabilirsiniz.`
        }
      ]
    }
  };

  const activeContent = content[activeTab];

  return (
    <div className="min-h-screen bg-slate-900">
      <CursorGlow />
      <ScrollProgress />
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-3xl top-0 right-1/4 animate-pulse"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
              <Scale className="w-4 h-4 text-cyan-400" />
              <span className="text-cyan-400 text-sm font-medium">Yasal Bilgiler</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Sözleşmeler &
              <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Politikalar</span>
            </h1>

            <p className="text-xl text-gray-400 leading-relaxed">
              Şeffaflık ve güven ilkelerimiz doğrultusunda, tüm yasal bilgilerimize buradan ulaşabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-4 sticky top-24">
                <nav className="space-y-2">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all ${
                        activeTab === tab.id
                          ? 'bg-gradient-to-r from-cyan-500/20 to-teal-500/20 border border-cyan-500/50 text-cyan-400'
                          : 'text-gray-400 hover:text-white hover:bg-slate-700/50'
                      }`}
                      data-testid={`legal-tab-${tab.id}`}
                    >
                      <tab.icon className="w-5 h-5" />
                      <span className="text-sm font-medium">{tab.title}</span>
                      {activeTab === tab.id && <ChevronRight className="w-4 h-4 ml-auto" />}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* Main Content */}
            <div className="lg:col-span-3">
              <div className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 md:p-12">
                <div className="flex items-center justify-between mb-8 pb-6 border-b border-slate-700/50">
                  <h2 className="text-3xl font-bold text-white">{activeContent.title}</h2>
                  <span className="text-sm text-gray-500">Son güncelleme: {activeContent.lastUpdated}</span>
                </div>

                <div className="space-y-8">
                  {activeContent.sections.map((section, index) => (
                    <div key={index}>
                      <h3 className="text-xl font-semibold text-cyan-400 mb-3">{section.title}</h3>
                      <p className="text-gray-400 leading-relaxed whitespace-pre-line">{section.content}</p>
                    </div>
                  ))}
                </div>

                {/* Contact for Legal */}
                <div className="mt-12 pt-8 border-t border-slate-700/50">
                  <div className="bg-slate-900/50 rounded-xl p-6">
                    <h4 className="text-white font-semibold mb-2">Sorularınız mı var?</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      Yasal konularla ilgili sorularınız için bizimle iletişime geçebilirsiniz.
                    </p>
                    <a 
                      href="mailto:legal@ruyan.com.tr"
                      className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
                    >
                      <FileText className="w-4 h-4" />
                      legal@ruyan.com.tr
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Legal;
